import format from 'date-fns/format';
import addDate from 'date-fns/add';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';

export { addDate };

dayjs.extend(utc);
dayjs.extend(duration);

export const formatDateTime = (
  date: Date | string | number,
  formatType = 'HH:mm',
  devider = '-'
) => {
  const type = formatType ? ` ${formatType}` : '';
  // @ts-ignore
  return format(new Date(date), `yyyy${devider}MM${devider}dd${type}`);
};

export const formatUTCTime = (
  date: Date | string | number,
  format = 'YYYY-MM-DD HH:mm'
) => {
  return dayjs(date).utc().format(format);
};

export const convertDuration = (diff: string | number, format = 'mm:ss') => {
  // @ts-ignore
  return dayjs.duration(diff).format(format);
};

export const diffTime = (
  date1: Date | string | number,
  date2: Date | string | number,
  unit: string
) => {
  // @ts-ignore
  return dayjs(date1).diff(dayjs(date2), unit);
};
